import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { BsBoxArrowInUpRight } from 'react-icons/bs';
import { BIDS_TABS, BID_STATUS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import ErrorBoundary from 'components/common/ErrorBoundary';
import CommonBids from './components/CommonBids';

const Bids = () => {
  const [activeTab, setActiveTab] = useState(BIDS_TABS.ACTIVE_BIDS);
  const navigate = useNavigate();
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <div className="d-flex align-items-center">
        <CustomTabs
          tabs={[
            BIDS_TABS.ACTIVE_BIDS,
            BIDS_TABS.EXPIRED_BIDS,
            BIDS_TABS.ACCEPTED_BIDS,
            BIDS_TABS.REJECTED_BIDS,
            BIDS_TABS.WITHDRAWN_BIDS,
          ]}
          selectedTab={activeTab}
          onTabChange={toggle}
          className="border-0 inner-list-tab"
        />
        <div
          aria-hidden="true"
          className="view-all-btn ms-auto text-decoration-none text-nowrap"
          onClick={() => navigate('/biddings')}
        >
          View All <BsBoxArrowInUpRight />
        </div>
      </div>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={BIDS_TABS.ACTIVE_BIDS}>
          {activeTab === BIDS_TABS.ACTIVE_BIDS && (
            <ErrorBoundary>
              <CommonBids status={BID_STATUS.IN_PROGRESS} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={BIDS_TABS.EXPIRED_BIDS}>
          {activeTab === BIDS_TABS.EXPIRED_BIDS && (
            <ErrorBoundary>
              <CommonBids status={BID_STATUS.EXPIRED} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={BIDS_TABS.ACCEPTED_BIDS}>
          {activeTab === BIDS_TABS.ACCEPTED_BIDS && (
            <ErrorBoundary>
              <CommonBids status={BID_STATUS.ACCEPTED} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={BIDS_TABS.REJECTED_BIDS}>
          {activeTab === BIDS_TABS.REJECTED_BIDS && (
            <ErrorBoundary>
              <CommonBids status={BID_STATUS.REJECTED} />
            </ErrorBoundary>
          )}
        </TabPane>
        <TabPane tabId={BIDS_TABS.WITHDRAWN_BIDS}>
          {activeTab === BIDS_TABS.WITHDRAWN_BIDS && (
            <ErrorBoundary>
              <CommonBids status={BID_STATUS.WITHDRAWN} />
            </ErrorBoundary>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default Bids;
